var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_169)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.55978 23.8696H31.4402C32.3043 23.8207 33 23.0978 33 22.2228V4.64674C33 3.74457 32.2663 3.00543 31.3641 3H4.63587C3.7337 3.00543 3 3.74457 3 4.64674V22.2174C3 23.0978 3.69565 23.8207 4.55978 23.8696Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9022 15.5163V23.8696H20.0761V15.5163H33V11.3424H20.0761V3H15.9022V11.3424H3V15.5163H15.9022Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4673 9.75543V3H31.375C32.0597 3.01087 32.6467 3.44022 32.8858 4.04348L21.4673 9.75543Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4673 17.1141V23.8696H31.4402C32.0978 23.8315 32.6521 23.4076 32.8858 22.8261L21.4673 17.1141Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5108 17.1141V23.8696H4.55967C3.90206 23.8315 3.34227 23.4076 3.11401 22.8152L14.5108 17.1141Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5108 9.75543V3H4.62488C3.9401 3.01087 3.34771 3.44565 3.11401 4.05435L14.5108 9.75543Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9.95652H7.15761L3 7.875V9.95652Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 9.95652H28.8206L33 7.86413V9.95652Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 16.913H28.8206L33 19.0054V16.913Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16.913H7.15761L3 18.9946V16.913Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 4.76632L22.6467 9.95654H24.9619L33 5.9348V4.76632Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3315 16.913H11.0163L3 20.9239V22.0924L13.3533 16.913H13.3315Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71739 9.96196H11.0326L3 5.94022V7.10327L8.71739 9.96196Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2554 16.9076H24.9402L33 20.9457V19.7826L27.2554 16.9076Z",
    fill: "#C8102E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_169",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_169"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_169",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/UnitedKingdom.8d61e0ed95ff59441207475d6678ad2f.svg";
export { ForwardRef as ReactComponent };